import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/movie',
    label: '电影',
    desc: '海量电影资源，覆盖多类型多地区',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20movie%20theme%20background%2C%20film%20reel%20and%20theater%20light%20beams%2C%20deep%20blue%20and%20warm%20amber%20gradient%2C%20minimal%20elegant%20design%2C%20no%20text&width=800&height=400&seq=qx-cat-01&orientation=landscape',
  },
  {
    to: '/category/tv',
    label: '电视剧',
    desc: '最新剧集全集追踪，连载持续更新',
    icon: 'ri-live-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20series%20theme%20background%2C%20stacked%20screens%20and%20soft%20glow%2C%20deep%20navy%20and%20warm%20orange%20gradient%2C%20modern%20minimal%20design%2C%20no%20text&width=800&height=400&seq=qx-cat-02&orientation=landscape',
  },
  {
    to: '/list',
    label: '全部影视',
    desc: '综合筛选与排序，快速定位想看内容',
    icon: 'ri-layout-grid-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20media%20library%20theme%20background%2C%20grid%20of%20glowing%20cards%2C%20deep%20teal%20and%20amber%20gradient%2C%20clean%20modern%20minimal%20design%2C%20no%20text&width=800&height=400&seq=qx-cat-03&orientation=landscape',
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative h-36 md:h-40 rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`${entry.label}分类入口`}
              title={`${entry.label} - 秋霞电影网`}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 to-primary-950/30"></div>
            <div className="relative h-full px-5 flex items-center gap-4">
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-background-50/15 text-background-50 text-2xl md:text-3xl shrink-0">
                <i className={entry.icon}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-bold text-background-50 text-lg md:text-xl flex items-center gap-2">
                  {entry.label}
                  <i className="ri-arrow-right-line text-accent-400 text-base"></i>
                </h3>
                <p className="text-background-200 text-xs md:text-sm mt-1 line-clamp-2">{entry.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}